import "./setiings.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  ListItem,
  Paper,
  Stack,
  TextField,
  Typography,
  Tooltip,
  Fab,
} from "@mui/material";
import {
  Add as AddIcon,
  Category as CategoryIcon,
  LocalOffer as TagIcon,
  Settings as SettingsIcon,
  Star as StarIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CloudUpload as CloudUploadIcon,
} from "@mui/icons-material";
import {
  arrayRemove,
  arrayUnion,
  doc,
  getDoc,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import { db, realtimeDB, storage } from "../../firebase";
import { ProgressDialog, ShowSnackBar } from "../../components/modal";
import { handleInputNumber } from "../../context/commonFunctions";
import { onValue, push, ref, remove, set, update } from "firebase/database";
import {
  getDownloadURL,
  uploadBytes,
  ref as storageRef,
  deleteObject,
} from "firebase/storage";
import { useUserChats } from "../../context/ChatsContext";

const Setiings = () => {
  const mainRef = doc(db, "Alphabet", "home");
  const { categories } = useUserChats();

  const [categoryData, setCategoryData] = useState({});
  const [open, setOpen] = useState(false);
  const [textFieldCatTitle, setTextFieldCatTitle] = useState("");
  const [tagsData, setTagsData] = useState([]);
  const [featuredBooksData, setFeaturedBooksData] = useState([]);
  const [textFieldTag, setTextFieldTag] = useState("");
  const [initialLoading, setInitialLoading] = useState(true);
  const [textFieldCredits, setTextFieldCredits] = useState("");
  const [textFieldReferBy, setTextFieldReferBy] = useState("");
  const [textFieldReferTo, setTextFieldReferTo] = useState("");
  const [openAddCategoryDialog, setOpenAddCategoryDialog] = useState(false);
  const [categorySelectedImage, setCategorySelectedImage] = useState(null);
  const [categoryBannerImage, setCategoryBannerImage] = useState(null);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [bannerImageURL, setBannerImageURL] = useState("");
  //cat dialog
  const [catDialogTitle, setCatDialogTitle] = useState("Add Category");
  const [catDialogButtonText, setCatDialogButtonText] = useState("Submit");
  const [textFieldFeaturedBook, setTextFieldFeaturedBook] = useState("");
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(
    "An unexpected error occurred. Please try again later."
  );

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
  };

  //sub category
  const addSubCategory = (subCategory) => {
    if (!subCategoryData.includes(subCategory)) {
      setSubCategoryData((prevSubCategory) => [
        ...prevSubCategory,
        subCategory,
      ]);
    }
  };

  const handleDeleteSubCategory = (subCategoryToRemove) => () => {
    setSubCategoryData((prevSubCategory) =>
      prevSubCategory.filter((sub) => sub !== subCategoryToRemove)
    );
  };
  //featured books
  const addFeaturedBook = async (featuredBook) => {
    if (!featuredBooksData.includes(featuredBook)) {
      try {
        setOpen(true);
        await updateDoc(mainRef, { featuredBooks: arrayUnion(featuredBook) });
        setOpen(false);
      } catch (error) {
        setOpen(false);
        alert("Error while adding book ID - " + error.message);
      }
    } else {
      alert("Already have this Book ID.");
    }
  };
  //tags

  const addTag = async (newTag) => {
    if (!tagsData.includes(newTag)) {
      try {
        setOpen(true);
        await updateDoc(mainRef, { tags: arrayUnion(newTag) });
        setOpen(false);
      } catch (error) {
        setOpen(false);
        alert("Error while adding tag - " + error.message);
      }
    } else {
      alert("Already have this tag.");
    }
  };
  const handleAddCategoryImageChange = (e) => {
    const selectedImage = e.target.files[0];
    if (selectedImage && selectedImage.type.startsWith("image/")) {
      setCategorySelectedImage(selectedImage);
    } else {
      setCategorySelectedImage(null);
      alert("Please select a valid image file.");
    }
  };
  const handleAddCategoryBannerChange = (e) => {
    const selectedImage = e.target.files[0];
    if (selectedImage && selectedImage.type.startsWith("image/")) {
      setCategoryBannerImage(selectedImage);
    } else {
      setCategoryBannerImage(null);
      alert("Please select a valid image file.");
    }
  };

  const handleDeleteCategory = (category) => async () => {
    try {
      setOpen(true);
      await remove(ref(realtimeDB, "categories/" + category));
      const deleteImage = storageRef(
        storage,
        "categories/" + category + "/image"
      );
      const deleteBanner = storageRef(
        storage,
        "categories/" + category + "/banner"
      );
      await Promise.all([
        deleteObject(deleteImage),
        deleteObject(deleteBanner),
      ]);
      setOpen(false);
      if (Object.keys(categoryData).length === 1) {
        setCategoryData({});
      }
    } catch (error) {
      alert(error);
      setOpen(false);
    }
  };

  const handleDeleteTag = (tagToRemove) => async () => {
    try {
      setOpen(true);
      await updateDoc(mainRef, { tags: arrayRemove(tagToRemove) });
      setOpen(false);
    } catch (error) {
      setOpen(false);
      alert("Error while deleting tag - " + error.message);
    }
  };
  const handleDeleteFeaturedBook = (bookToRemove) => async () => {
    try {
      setOpen(true);
      await updateDoc(mainRef, { featuredBooks: arrayRemove(bookToRemove) });
      setOpen(false);
    } catch (error) {
      setOpen(false);
      alert("Error while deleting Book Id - " + error.message);
    }
  };
  const updateOtherDetails = async () => {
    try {
      setOpen(true);
      await updateDoc(mainRef, {
        creditValue: parseFloat(textFieldCredits, 10) || 0,
        referralVal: {
          by: parseInt(textFieldReferBy, 10) || 0,
          to: parseInt(textFieldReferTo, 10) || 0,
        },
      });
      setOpen(false);
    } catch (error) {
      setOpen(false);
      alert("Error " + error.message);
    }
  };
  const handleClicktag = (tagValue) => async () => {
    setTextFieldTag(tagValue);
  };
  const handleClickFeaturedBook = (featuredBook) => async () => {
    setTextFieldFeaturedBook(featuredBook);
  };
  const handleCatclick = (category) => async () => {
    setCatDialogButtonText("Update");
    setCatDialogTitle("Update '" + categoryData[category].title + "' Category");
    setTextFieldCatTitle(category); // This is the category key, not the title
    setBannerImageURL(categoryData[category].banner);
    setSubCategoryData(categoryData[category].subCategories || []);
    setOpenAddCategoryDialog(true);
  };

  const handleInputChangeTag = (event) => {
    const { value } = event.target;
    setTextFieldTag(value);
  };

  const handleInputChangeFeaturedBook = (event) => {
    const { value } = event.target;
    setTextFieldFeaturedBook(value);
  };

  useEffect(() => {
    setCategoryData(categories);
  }, [categories]);

  useEffect(() => {
    document.title = "Wishallbook >> Settings";

    const unsubscribe = onSnapshot(mainRef, (docSnap) => {
      try {
        setInitialLoading(false);
        if (docSnap.exists()) {
          /* const categories = docSnap.data().categories;
          if (categories) {
            setCategoryData(categories);
          }*/
          const tags = docSnap.data().tags;
          if (tags) {
            setTagsData(tags);
          }

          const featuredBooks = docSnap.data().featuredBooks;
          if (featuredBooks) {
            setFeaturedBooksData(featuredBooks);
          }

          const creditValue = docSnap.data().creditValue;
          if (creditValue) {
            setTextFieldCredits(creditValue);
          }
          const referralVal = docSnap.data().referralVal;
          if (referralVal) {
            setTextFieldReferBy(referralVal.by);
            setTextFieldReferTo(referralVal.to);
          }
        }
      } catch (error) {
        console.log("Error retrieving banners:", error);
      }
    });

    return () => unsubscribe();
  }, []);

  const updateImageWithData = async (refid, refVal) => {
    setOpenAddCategoryDialog(false);
    setOpen(true);

    try {
      const categoryImgRef = storageRef(
        storage,
        `categories/${refid}/${refVal}`
      );
      const snapshot = await uploadBytes(
        categoryImgRef,
        refVal === "banner" ? categoryBannerImage : categorySelectedImage
      );
      const url = await getDownloadURL(snapshot.ref);
      const imageurl = refVal === "banner" ? "banner" : "image";

      await update(ref(realtimeDB, "categories/" + refid), {
        subCategories: subCategoryData,
        [imageurl]: url,
      });
      alert("Updated");
      setSubCategoryData([]);
      setCategoryBannerImage(null);
      setCategorySelectedImage(null);
      setTextFieldCatTitle("");
      setOpen(false);
    } catch (error) {
      setOpen(false);
      alert(error.message || "An error occurred");
    }
  };

  const uploadCategoryImages = async () => {
    setOpenAddCategoryDialog(false);
    setOpen(true);

    try {
      // Generate a new unique ID for the category
      const newCategoryRef = push(ref(realtimeDB, "categories"));
      const newCategoryId = newCategoryRef.key;

      if (!newCategoryId) {
        throw new Error("Failed to generate a new category ID");
      }

      const categoryImgRef1 = storageRef(
        storage,
        `categories/${newCategoryId}/image`
      );
      const categoryImgRef2 = storageRef(
        storage,
        `categories/${newCategoryId}/banner`
      );

      // Upload both images concurrently
      const [snapshotImage, snapshotBanner] = await Promise.all([
        uploadBytes(categoryImgRef1, categorySelectedImage),
        uploadBytes(categoryImgRef2, categoryBannerImage),
      ]);

      // Get download URLs for both images
      const [urlImage, urlBanner] = await Promise.all([
        getDownloadURL(snapshotImage.ref),
        getDownloadURL(snapshotBanner.ref),
      ]);

      // Save category data with both image URLs
      await set(newCategoryRef, {
        image: urlImage,
        banner: urlBanner,
        title: textFieldCatTitle.trim(),
        subCategories: subCategoryData,
      });

      alert("Added");
      setSubCategoryData([]);
      setCategoryBannerImage(null);
      setCategorySelectedImage(null);
      setTextFieldCatTitle("");
      setOpen(false);
    } catch (error) {
      setOpen(false);
      alert(error.message || "An error occurred");
    }
  };

  /*const uploadCategoryImage = async () => {
    setOpenAddCategoryDialog(false);
    setOpen(true);
    const categoryImgRef = storageRef(
      storage,
      "categories/" + textFieldCatTitle
    );

    uploadBytes(categoryImgRef, categorySelectedImage)
      .then((snapshot) => {
        getDownloadURL(snapshot.ref)
          .then(async (url) => {
            await set(
              ref(
                realtimeDB,
                "categories/" + textFieldCatTitle.trim().toLocaleLowerCase()
              ),
              {
                image: url,
                subCategories: subCategoryData,
              }
            );
            alert("Added");
            setSubCategoryData([]);
            setCategorySelectedImage(null);
            setTextFieldCatTitle("");

            setOpen(false);
          })
          .catch((error) => {
            setOpen(false);
            alert(error.message);
          });
      })
      .catch((error) => {
        setOpen(false);
        alert(error);
      });
  };*/

  return (
    <div className="settingsParent">
      <Sidebar />

      {initialLoading && (
        <div className="settingsContainer">
          <Box className="initialItem">
            <CircularProgress size={60} />
            <Typography variant="h6" sx={{ mt: 2, color: "text.secondary" }}>
              Loading Settings...
            </Typography>
          </Box>
        </div>
      )}

      {!initialLoading && (
        <div className="settingsContainer">
          <Container maxWidth="xl" sx={{ py: 3 }}>
            {/* Header */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                sx={{ fontWeight: 700, mb: 1, color: "#1976d2" }}
              >
                Settings
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Manage your application settings, categories, tags, and featured
                content
              </Typography>
            </Box>

            <Grid container spacing={3}>
              {/* Categories Section */}
              <Grid item xs={12} lg={6}>
                <Card elevation={3} sx={{ height: "fit-content" }}>
                  <CardHeader
                    avatar={<CategoryIcon color="primary" />}
                    title="Categories"
                    subheader={`${Object.keys(categoryData).length} categories`}
                    action={
                      <Tooltip title="Add Category">
                        <IconButton
                          color="primary"
                          onClick={() => {
                            setCatDialogButtonText("Submit");
                            setCatDialogTitle("Add Category");
                            setTextFieldCatTitle("");
                            setSubCategoryData([]);
                            setOpenAddCategoryDialog(true);
                          }}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    }
                  />
                  <CardContent>
                    {Object.keys(categoryData).length !== 0 ? (
                      <Stack
                        direction="row"
                        spacing={1}
                        useFlexGap
                        flexWrap="wrap"
                        sx={{ mb: 2 }}
                      >
                        {Object.keys(categoryData).map((category) => (
                          <Chip
                            key={category}
                            avatar={
                              <Avatar src={categoryData[category].image} />
                            }
                            label={categoryData[category].title}
                            onClick={handleCatclick(category)}
                            onDelete={handleDeleteCategory(category)}
                            sx={{
                              "&:hover": {
                                backgroundColor: "primary.light",
                                color: "white",
                              },
                            }}
                          />
                        ))}
                      </Stack>
                    ) : (
                      <Box sx={{ textAlign: "center", py: 4 }}>
                        <CategoryIcon
                          sx={{ fontSize: 48, color: "text.disabled", mb: 2 }}
                        />
                        <Typography color="text.secondary">
                          No categories yet. Add your first category to get
                          started.
                        </Typography>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              {/* Tags Section */}
              <Grid item xs={12} lg={6}>
                <Card elevation={3} sx={{ height: "fit-content" }}>
                  <CardHeader
                    avatar={<TagIcon color="secondary" />}
                    title="Tags"
                    subheader={`${tagsData.length} tags`}
                  />
                  <CardContent>
                    <TextField
                      fullWidth
                      label="Add New Tag"
                      value={textFieldTag}
                      onChange={handleInputChangeTag}
                      placeholder="Enter tag name and press Enter"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <TagIcon color="action" />
                          </InputAdornment>
                        ),
                      }}
                      onKeyDown={(e) => {
                        if (
                          e.key === "Enter" &&
                          e.target.value.trim().length !== 0
                        ) {
                          const newTag = e.target.value;
                          addTag(newTag);
                          setTextFieldTag("");
                        }
                      }}
                      sx={{ mb: 3 }}
                    />

                    {tagsData.length > 0 ? (
                      <Stack
                        direction="row"
                        spacing={1}
                        useFlexGap
                        flexWrap="wrap"
                      >
                        {tagsData.map((data, index) => (
                          <Chip
                            key={index}
                            label={data}
                            onClick={handleClicktag(data)}
                            onDelete={handleDeleteTag(data)}
                            color="secondary"
                            variant="outlined"
                            sx={{
                              "&:hover": {
                                backgroundColor: "secondary.light",
                                color: "secondary",
                              },
                            }}
                          />
                        ))}
                      </Stack>
                    ) : (
                      <Box sx={{ textAlign: "center", py: 4 }}>
                        <TagIcon
                          sx={{ fontSize: 48, color: "text.disabled", mb: 2 }}
                        />
                        <Typography color="text.secondary">
                          No tags yet. Add tags to help categorize your content.
                        </Typography>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              {/* System Settings */}
              <Grid item xs={12} lg={6}>
                <Card elevation={3}>
                  <CardHeader
                    avatar={<SettingsIcon color="success" />}
                    title="System Settings"
                    subheader="Configure application parameters"
                  />
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Credit Value"
                          value={textFieldCredits}
                          inputProps={{ maxLength: 4 }}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (/^\d*\.?\d*$/.test(val)) {
                              setTextFieldCredits(val);
                            }
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                ₹
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Referral Reward (By User)"
                          value={textFieldReferBy}
                          inputProps={{ maxLength: 4 }}
                          onInput={handleInputNumber}
                          onChange={(e) => {
                            const val = e.target.value;
                            setTextFieldReferBy(val);
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                pts
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Referral Reward (To User)"
                          value={textFieldReferTo}
                          onInput={handleInputNumber}
                          inputProps={{ maxLength: 4 }}
                          onChange={(e) => {
                            const val = e.target.value;
                            setTextFieldReferTo(val);
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                pts
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          fullWidth
                          variant="contained"
                          color="success"
                          onClick={updateOtherDetails}
                          sx={{ py: 1.5 }}
                        >
                          Update Settings
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Featured Books */}
              <Grid item xs={12} lg={6}>
                <Card elevation={3}>
                  <CardHeader
                    avatar={<StarIcon color="warning" />}
                    title="Featured Books"
                    subheader={`${featuredBooksData.length}/9 books featured`}
                  />
                  <CardContent>
                    <TextField
                      fullWidth
                      label="Book ID"
                      value={textFieldFeaturedBook}
                      onChange={handleInputChangeFeaturedBook}
                      placeholder="Enter book ID and press Enter"
                      helperText="Maximum 9 books allowed"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <StarIcon color="action" />
                          </InputAdornment>
                        ),
                      }}
                      onKeyDown={async (e) => {
                        if (
                          e.key === "Enter" &&
                          e.target.value.trim().length !== 0
                        ) {
                          const textValue = e.target.value;
                          const docRef = doc(db, "eLibrary", textValue);

                          if (featuredBooksData.length > 8) {
                            setOpenSnackBar(true);
                            setSnackbarMessage("Maximum limit reached.");
                          } else {
                            try {
                              setOpen(true);
                              const docSnap = await getDoc(docRef);
                              setOpen(false);
                              if (docSnap.exists()) {
                                addFeaturedBook(textValue);
                                setTextFieldFeaturedBook("");
                              } else {
                                setOpenSnackBar(true);
                                setSnackbarMessage(
                                  "We couldn't find a book with that ID"
                                );
                              }
                            } catch (error) {
                              setOpen(false);
                              setOpenSnackBar(true);
                            }
                          }
                        }
                      }}
                      sx={{ mb: 3 }}
                    />

                    {featuredBooksData.length > 0 ? (
                      <Stack
                        direction="row"
                        spacing={1}
                        useFlexGap
                        flexWrap="wrap"
                      >
                        {featuredBooksData.map((data, index) => (
                          <Chip
                            key={index}
                            label={data}
                            onClick={handleClickFeaturedBook(data)}
                            onDelete={handleDeleteFeaturedBook(data)}
                            color="warning"
                            variant="outlined"
                            sx={{
                              "&:hover": {
                                backgroundColor: "warning.light",
                                color: "warning",
                              },
                            }}
                          />
                        ))}
                      </Stack>
                    ) : (
                      <Box sx={{ textAlign: "center", py: 4 }}>
                        <StarIcon
                          sx={{ fontSize: 48, color: "text.disabled", mb: 2 }}
                        />
                        <Typography color="text.secondary">
                          No featured books yet. Add book IDs to feature them in
                          the app.
                        </Typography>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Container>
          <ShowSnackBar
            message={snackbarMessage}
            type={"error"}
            handleCloseSnackBar={handleCloseSnackBar}
            openSnackBar={openSnackBar}
          />
          <ProgressDialog loading={open} message={"Please wait..."} />
          <Dialog
            open={openAddCategoryDialog}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: { borderRadius: 2 },
            }}
          >
            <DialogTitle sx={{ pb: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CategoryIcon color="primary" />
                <Typography variant="h6">{catDialogTitle}</Typography>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={3} sx={{ mt: 1 }}>
                {catDialogButtonText.toLowerCase() !== "update" && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Category Title"
                      value={textFieldCatTitle}
                      onChange={(e) => setTextFieldCatTitle(e.target.value)}
                      placeholder="Enter category name"
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography
                      variant="subtitle1"
                      sx={{ mb: 2, fontWeight: 600 }}
                    >
                      Category Image
                    </Typography>
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      startIcon={<CloudUploadIcon />}
                      sx={{ py: 2 }}
                    >
                      Choose Category Image
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleAddCategoryImageChange}
                        hidden
                      />
                    </Button>
                    {categorySelectedImage && (
                      <Typography
                        variant="body2"
                        color="success.main"
                        sx={{ mt: 1 }}
                      >
                        ✓ Image selected: {categorySelectedImage.name}
                      </Typography>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography
                      variant="subtitle1"
                      sx={{ mb: 2, fontWeight: 600 }}
                    >
                      Banner Image
                    </Typography>
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      startIcon={<CloudUploadIcon />}
                      sx={{ py: 2 }}
                    >
                      Choose Banner Image
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleAddCategoryBannerChange}
                        hidden
                      />
                    </Button>
                    {categoryBannerImage && (
                      <Typography
                        variant="body2"
                        color="success.main"
                        sx={{ mt: 1 }}
                      >
                        ✓ Banner selected: {categoryBannerImage.name}
                      </Typography>
                    )}
                    {catDialogButtonText.toLowerCase() === "update" &&
                      bannerImageURL && (
                        <Button
                          variant="text"
                          href={bannerImageURL}
                          target="_blank"
                          sx={{ mt: 1 }}
                        >
                          View Current Banner
                        </Button>
                      )}
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 2, fontWeight: 600 }}
                  >
                    Subcategories
                  </Typography>
                  <TextField
                    fullWidth
                    label="Add Subcategory"
                    placeholder="Enter subcategory name and press Enter"
                    onKeyDown={(e) => {
                      if (
                        e.key === "Enter" &&
                        e.target.value.trim().length !== 0
                      ) {
                        const newTag = e.target.value.toLowerCase();
                        addSubCategory(newTag);
                        e.target.value = "";
                      }
                    }}
                    sx={{ mb: 2 }}
                  />

                  {subCategoryData.length > 0 && (
                    <Stack
                      direction="row"
                      spacing={1}
                      useFlexGap
                      flexWrap="wrap"
                    >
                      {subCategoryData.map((data, index) => (
                        <Chip
                          key={index}
                          label={data}
                          onDelete={handleDeleteSubCategory(data)}
                          color="primary"
                          variant="outlined"
                        />
                      ))}
                    </Stack>
                  )}
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setSubCategoryData([]);
                  setCategorySelectedImage(null);
                  setCategoryBannerImage(null);
                  setTextFieldCatTitle("");
                  setOpenAddCategoryDialog(false);
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={async () => {
                  if (catDialogButtonText.toLowerCase() === "update") {
                    if (subCategoryData.length === 0) {
                      alert("Sub Category is Empty..");
                    } else {
                      if (
                        categorySelectedImage === null &&
                        categoryBannerImage === null
                      ) {
                        setOpen(true);
                        setOpenAddCategoryDialog(false);
                        await update(
                          ref(realtimeDB, "categories/" + textFieldCatTitle),
                          {
                            subCategories: subCategoryData,
                          }
                        );
                        alert("Added");
                        setSubCategoryData([]);
                        setCategorySelectedImage(null);
                        setCategoryBannerImage(null);
                        setTextFieldCatTitle("");

                        setOpen(false);
                      } else if (categoryBannerImage !== null) {
                        //update only banner image and subcategories
                        updateImageWithData(textFieldCatTitle, "banner");
                      } else if (categorySelectedImage !== null) {
                        //update only category image and subcategories
                        updateImageWithData(textFieldCatTitle, "image");
                      }
                    }
                  } else {
                    if (textFieldCatTitle.trim().length === 0) {
                      alert("Enter Category Title");
                    } else if (categorySelectedImage === null) {
                      alert("Please select Category Image");
                    } else if (categoryBannerImage === null) {
                      alert("Please select banner Image");
                    } else if (subCategoryData.length === 0) {
                      alert("Sub Category is Empty..");
                    } else {
                      uploadCategoryImages();
                    }
                  }
                }}
              >
                {catDialogButtonText}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </div>
  );
};

export default Setiings;
